jQuery(function(){
    if (jQuery("#schuifblokcontainer").length > 0)
    {

        //instellingen aanpasbaar
        var automatisch             = 1; // 1=aan / 0=uit
        var beginnenbij             = 0; // beginnen bij
        var hoelangstilstaan        = 8000; // 1000 = 1sec
        var schuifknopcss           = new Array("background-color","#ed760e","#8f8f8e"); // css, active, nonactive
        var schuifknopcss2           = new Array("opacity","1.0","0.8"); // css, active, nonactive
        var commentaarinbeeld       = "0px"; // positie binnnen balk
        var commentaarbuitenbeeld   = "179px"; // positie buiten balk
        var resetpositie            = "0px"; // blok left positie bij reset/begin

        //instellingen niet aanpasbaar
        var totaal                  = jQuery(".schuifblok").size();
        var breed                   = jQuery(".schuifblok").width();
        var comheight               = jQuery(".schuifblokcommentaar").height();
        var pauze                   = false;
        var huidig                  = -1;
        var timeoutcallback;

        if (totaal > 1)
            timeoutcallback = setTimeout(autoschuiven,hoelangstilstaan);

        function schuivenactiveknop($positie)
        {
            jQuery('.schuifnaarpositie').css(schuifknopcss[0],schuifknopcss[2]);
            jQuery('.schuifnaarpositie:eq('+$positie+')').css(schuifknopcss[0],schuifknopcss[1]);
            jQuery('.schuifnaarpositie').css(schuifknopcss2[0],schuifknopcss2[2]);
            jQuery('.schuifnaarpositie:eq('+$positie+')').css(schuifknopcss2[0],schuifknopcss2[1]);
        }

        function schuifcommentaar($huidig,$positie)
        {
            jQuery('.schuifblokcommentaar:eq('+$huidig+')').animate({"top":commentaarbuitenbeeld},function(){
                jQuery('.schuifblokcommentaar:eq('+$huidig+')').css("top","-"+comheight+"px");
            });
            jQuery('.schuifblokcommentaar:eq('+$positie+')').animate({"top":commentaarinbeeld});
        }

        jQuery("#schuifblokcontainer").hover(function(){
            pauze = true;
            jQuery('#schuifblokpauze').fadeIn();
        },function(){
            pauze = false;
            jQuery('#schuifblokpauze').fadeOut();
        });

        function autoschuiven()
        {
            if(automatisch==1)
            {
                if(huidig < (totaal-1))
                {
                    positie = huidig + 1;
                    schuiven(positie);
                }
                else if(huidig == (totaal-1))
                {
                    schuiven(beginnenbij)
                }
            }
        }

        jQuery('.schuifnaarpositie').click(function(){
            positie = jQuery(".schuifnaarpositie").index(this);
            schuiven(positie);
            return false;
        });

        function schuiven(positie)
        {
            clearTimeout(timeoutcallback);
            if(!pauze)
            {
                if(positie==huidig){}
                else
                {
                    jQuery('.schuifblok:eq('+huidig+')').fadeOut();
                    jQuery('.schuifblok:eq('+positie+')').fadeIn();
                    schuivenactiveknop(positie);
                    schuifcommentaar(huidig,positie);
                    huidig = positie;
                }
            }
            timeoutcallback = setTimeout(autoschuiven,hoelangstilstaan);
        }

        schuiven(beginnenbij);
    }

});